import whatsappService from '@/services/whatsapp';

// ----------------------------------------------------------------------------
// OPTIONS
// ----------------------------------------------------------------------------
export const namespaced = true;

// ----------------------------------------------------------------------------
// STATE
// ----------------------------------------------------------------------------
export const state = {
  settings: null,
};

// ----------------------------------------------------------------------------
// MUTATIONS
// ----------------------------------------------------------------------------
export const mutations = {
  SET_SETTINGS(state, settings) {
    state.settings = settings;
  },
};

// ----------------------------------------------------------------------------
// ACTIONS
// ----------------------------------------------------------------------------
export const actions = {
  fetchSettings({ commit }) {
    return whatsappService.getSettings().then((response) => {
      commit('SET_SETTINGS', response.data.data);
      return response.data.data;
    });
  },

  updateSettings({ commit }, data) {
    return whatsappService.updateSettings(data).then((response) => {
      commit('SET_SETTINGS', response.data.data);
      return response.data.data;
    });
  },

  sendTest(context, phone) {
    return whatsappService.sendTest(phone).then((response) => response.data);
  },
};
